import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { exerciseByIdQuery } from '../constants/queries';
import { useToastContext } from '../components/UI/ToastManager';

export type ExerciseByIdQueryResponse = {
  exercise: {
    id: string;
    name: string;
    backgroundVideo: {
      duration: string;
      source: string;
      title: string;
    };
    description: {
      language: string;
      text: string;
    }[];
    displayName: {
      language: string;
      text: string;
    }[];
    poster: {
      source: string;
    };
    sideChange: boolean;
    videos: {
      language: string;
      video: {
        duration?: string;
        height?: string;
        source?: string;
        title?: string;
        width?: string;
      };
    }[];
  };
};

export function useExerciseByIdQuery(id: string | null) {
  const { showError } = useToastContext();

  return useQuery<ExerciseByIdQueryResponse['exercise']>({
    queryKey: ['exercise', id],
    queryFn: () => graphqlRequest<ExerciseByIdQueryResponse>(exerciseByIdQuery, { id }, showError).then(result => result.exercise),
    enabled: !!id, // Only run query if id is provided
  });
} 